<template>
  <div>
    <!-- 显示用户信息 -->
    <div class="account-info" v-if="isShowInfo" :style="generateInnerStyles(config.logged_in)">
      <div class="info" v-if="!!isOnline">
        <div v-if="userInfo && userInfo.account">
          <span class="main-title" :style="'color:' + config.logged_in.main_title_color">{{ config.logged_in.game_name
          }}</span>
          <template v-if="userInfo.account">

            <span v-if="newUserInfo.role_name" class="sub-title" :style="'color:' + config.logged_in.sub_title_color">{{
              newUserInfo["role_name"] + "[" + newUserInfo["server_name"] + "]"
            }}</span>

            <span v-else class="sub-title" :style="'color:' + config.logged_in.sub_title_color">{{
              userInfo["account"]
            }}</span>
          </template>
          <template v-else>
            <span class="sub-title" :style="'color:' + config.logged_in.sub_title_color">{{ userInfo["role_name"] + "["
              +
              userInfo["os"] + "]" }}</span>
          </template>
        </div>
        <div v-else>
          <span class="main-title" :style="'color:' + config.logged_in.main_title_color">{{
            config.not_logged_in.title }}</span>
          <span class="sub-title" :style="'color:' + config.logged_in.sub_title_color">{{
            config.not_logged_in.sub_title }}</span>
        </div>
      </div>
      <div class="btn official-btn ambush" data="0" title="官网" :style="config.operation_btn.office_website.style || ''">
        <a v-if="isOnline != 0" href="javascript:;" @click="onOfficial()">
          <img :src="config.operation_btn.office_website.img" alt="官网" />
        </a>
      </div>
      <div :class="userInfo.account ? 'btn os-btn' : 'btn login-btn'" :style="loginOsStyle()">

        <!-- <img v-if="userInfo.account && userInfo.role_name" alt="切换账户" :src="config.operation_btn.change_account.img"
          @click="changeAccount()" /> -->

        <img v-if="userInfo.account" alt="注销渠道账户" :src="config.operation_btn.logout.img" @click="onLogout()" />


        <img v-else-if="isOnline
          ? userInfo.account
          : !isOnline && userInfo.account
        " alt="注销渠道账户" :src="config.operation_btn.logout.img" @click="onLogout()" />
        <img v-else alt="登陆" :src="config.operation_btn.login.img" @click="onLogin()" />
      </div>
    </div>
    <!-- 不显示用户信息 -->
    <div v-else class="account-info account-info-help" title="头部信息" :style="generateInnerStyles(config.not_logged_in)">
      <div class="info">
        <span class="main-title" :style="'color:' + config.logged_in.main_title_color">{{
          config.not_logged_in.title }}</span>
        <span class="sub-title" :style="'color:' + config.logged_in.sub_title_color">{{
          config.not_logged_in.sub_title }}</span>
      </div>
      <div class="btn official-btn ambush" data="0" title="官网" :style="config.operation_btn.office_website.style || ''">
        <a href="javascript:;" @click="onOfficial()">
          <img :src="config.operation_btn.office_website.img" alt="官网" />
        </a>
      </div>
      <div class="btn tab-participation" title="参与活动" :style="config.operation_btn.join_active.style || ''">
        <a href="javascript:;" @click="onActivePage()">
          <img :src="config.operation_btn.join_active.img" alt="参与活动" />
        </a>
      </div>
    </div>

    <!-- 渠道账户注销弹窗 -->
    <div class="popup_wrap logout-confirm-wrap" v-show="logoutPopup">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="popup-wrap-box" v-show="logoutPopup">
          <div class="content">
            <p>{{ msg.loginOutMsg }}</p>
          </div>
          <div class="operation">
            <div @click.stop="changeLogoutPopup(false)">{{ msg.cancel }}</div>
            <div @click.stop="confirmLogout()">{{ msg.sure }}</div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="logoutPopup" @click.stop="changeLogoutPopup(false)"></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { transformStyle } from "@/utils/utils";
import { LogoutAPI } from "@/api/login";
export default {
  name: "HEADER",
  created() {
    this.msg = this.msgList[this.language] || this.msgList["zh-cn"];
  },
  mounted() {
    console.log(this.newUserInfo, 'newUserInfo')
    console.log(this.userInfo, 'userInfo')
  },
  updated() {
  },
  props: {
    isShowInfo: {
      type: Boolean,
      default: true
    },
    activeLink: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: null
    },
    isOnline: {
      type: Number,
      default: 0
    },
    newUserInfo: {
      type: Object,
      default: () => ({
        role_name: ''
      })
    },
    language: {
      type: String,
      default: "zh-cn"
    }
  },
  data() {
    return {
      logoutPopup: false,
      msgList: {
        "zh-tw": {
          loginOutMsg: "確認註銷當前用戶？",
          cancel: '取消',
          sure: "確認"
        },
        "zh-cn": {
          loginOutMsg: "确认注销当前用户？",
          cancel: '取消',
          sure: "确认"
        },
        "en": {
          loginOutMsg: "連結成功",
          cancel: '取消',
          sure: "确认"
        },
        "jp": {
          loginOutMsg: "連結成功",
          cancel: '取消',
          sure: "确认"
        },

      },
      msg: {}
    };
  },
  filters: {
    filterName(str) {
      switch (str) {
        case 26:
          return "光子服";
        case 42:
          return "正式服";
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    // 处理行内样式
    generateInnerStyles(cssAttr) {
      return transformStyle(cssAttr);
    },
    loginOsStyle() {
      let style = "";
      const config = this.config;
      const userInfo = this.userInfo;
      if (userInfo.role_id && userInfo.account) {
        style = config.operation_btn.change_account.style;
      } else if (userInfo.role_id && !userInfo.account) {
        style = config.operation_btn.logout.style;
      } else {
        style = config.operation_btn.login.style;
      }
      return style || "";
    },
    isCount() { },
    // 切换账号
    changeAccount() {
      this.changeOsPopup(true);
    },
    // 登陆
    onLogin() {
      if (this.language == 'zh-cn') {
        this.changeLoginPopup(true);
      } else {
        console.log(this.language);
        this.$emit("onLogin");
      }
    },
    // 注销渠道账户
    onLogout() {
      if (this.language == 'zh-cn') {
        this.changeLogoutPopup(true);
      } else {
        this.changeLogoutPopup(true);
      }
    },
    changeLogoutPopup(val) {
      this.logoutPopup = val;
    },
    // 官网
    onOfficial() {
      console.log("官网");
      window.location.href = this.config.operation_btn.office_website.link;
      this.$emit("onOfficial");
    },
    onActivePage() {
      window.location.href = this.config.operation_btn.join_active.link;
    },
    confirmLogout() {
      console.log("确认注销");
      const that = this
      if (this.language == 'zh-cn') {
        LogoutAPI().then(response => {
          if (Number(response.code) === 200) {
            this.$emit("reInit");
            // 清空数据 控制弹窗
            window.localStorage.setItem("access_token", "");
            this.setInitUserInfo();
            this.setInitActiveInfo();
            this.changeLogoutPopup(false);
            this.changeLoginPopup(true);
          }
        });
      } else {
        window.localStorage.setItem("access_token", "");
        window.localStorage.setItem("token", "");
        this.changeLogoutPopup(false);
        this.$emit("reInit");
      }
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitUserInfo",
      "setInitActiveInfo"
    ])
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/5thReport/Header/index.vue